import "./incentive.scss"
import "./static/incentive-desktop.png"
import "./static/incentive-mobile.png"
import "./static/incentive-desktop.webp"
import "./static/incentive-mobile.webp"
